import * as t from "../actions";

const initialContactState: string[] = [];

export default function (state = initialContactState, action: any) {
  switch (action.type) {
    case t.EDIT_CONTACTS:
      return action.payload;

    case t.ADD_REPORT:
      return action.payload.contacts;

    case t.FLUSH_REPORT:
      return initialContactState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/reducer/contacts.ts